import React, { useState, useEffect } from 'react';

// Light is the default theme (set on <html> before the app renders).
function getTheme() {
  return document.documentElement.getAttribute('data-theme') || 'light';
}

// The Okiru logo for the surface it sits on:
// - themed app surfaces: the blue Learn mark, adjusted for light and dark
// - fixed light surfaces: the dark-text wordmark for reports
// - dark surfaces: the existing white logo (okiru-logo-white.png)
// `surface` follows the theme by default; pass 'light' for something that is
// always white (a printable letterhead). `symbol` shows the circle mark only,
// which reads on both, for tight spaces such as the collapsed sidebar.
export const LOGO_FOR_LIGHT = '/okiru-logo-light.png';
export const LOGO_FOR_DARK = '/okiru-logo-white.png';
export const LOGO_SYMBOL = '/okiru-symbol-only.png';
export const LOGO_TOOLKIT = '/brand/okiru-circle-source.png';

export default function OkiruLogo({ height = 36, className = '', surface = 'theme', symbol = false }) {
  const [theme, setTheme] = useState(getTheme);

  useEffect(() => {
    if (surface !== 'theme') return undefined;
    const observer = new MutationObserver(() => setTheme(getTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, [surface]);

  const onLight = surface === 'light' || (surface === 'theme' && theme !== 'dark');
  const toolkitMark = surface === 'theme';
  const src = toolkitMark ? LOGO_TOOLKIT : symbol ? LOGO_SYMBOL : onLight ? LOGO_FOR_LIGHT : LOGO_FOR_DARK;
  const variant = symbol ? 'okiru-logo--symbol' : onLight ? 'okiru-logo--light' : 'okiru-logo--dark';

  return (
    <img
      src={src}
      alt={toolkitMark ? "Okiru Learn" : "Okiru"}
      height={height}
      className={`okiru-logo ${variant}${className ? ` ${className}` : ''}`}
      style={{ display: 'block', width: 'auto', objectFit: 'contain', ...(toolkitMark ? { filter: onLight ? 'brightness(0) saturate(100%) invert(35%) sepia(93%) saturate(1961%) hue-rotate(212deg) brightness(95%) contrast(93%)' : 'brightness(0) saturate(100%) invert(80%) sepia(48%) saturate(648%) hue-rotate(183deg) brightness(99%) contrast(100%)' } : {}) }}
    />
  );
}
